<nz-layout class="app-layout" style="min-height: 100vh">
  <!-- Header -->
  <nz-header
    class="nav_header"
    [ngClass]="{ 'prod-header-color': isProd, 'dev-header-color': !isProd }"
    style="display: flex; justify-content: space-between; align-items: center; padding: 0 24px"
  >
    <!-- Logo -->
    <div
      style="display: flex; align-items: center; gap: 12px"
      [ngClass]="{ 'prod-header-color': isProd, 'dev-header-color': !isProd }"
    >
      <a routerLink="/" style="display: flex; align-items: center; gap: 8px; text-decoration: none">
        <img src="assets/img/logo.png" alt="Condor CRM" height="32" />
        <h1 style="margin: 0; font-size: 20px; color: white">Condor CRM</h1>
      </a>
    </div>

    <!-- Navigation & Actions -->
    <div style="display: flex; align-items: center; gap: 24px">
      <!-- Menu -->
      <ul
        nz-menu
        nzMode="horizontal"
        nzTheme="dark"
        [style.backgroundColor]="!isProd ? 'indianred' : '#1797c0'"
        style="border-bottom: none"
      >
        <li
          nz-menu-item
          *ngFor="let item of views"
          routerLinkActive="active"
          [style.borderColor]="!isProd ? 'darkred' : '#1797c0'"
        >
        @if(item.havePermission){
          <a [routerLink]="item.url" style="color: white">{{ item.name | translate }}</a>
        }
        </li>
      </ul>

      <!-- User Actions -->
      <ul class="nav" style="display: flex; align-items: center; gap: 16px; list-style: none; margin: 0">
        <app-header></app-header>
      </ul>
    </div>
  </nz-header>

  <!-- Main Content -->
  <nz-content style="min-height: calc(100vh - 64px - 70px); background: #fff">
    <router-outlet></router-outlet>
  </nz-content>

  <!-- Footer -->
  <nz-footer style="text-align: center">
    © 2025 Condor CRM. Todos los derechos reservados.
  </nz-footer>
</nz-layout>